module.exports = __webpack_public_path__ + "media/images/img_check-25b4ca9dcdccd0980b5ab0f5fe498045.png";